import React, { memo, useMemo } from 'react';
import './_twig.files.code.scss'
import './_twig.files.code.dark-mode.scss'
import { Button } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { isEqual } from 'lodash';
import classNames from 'classnames';
import CodeMirror from '../../../../../../components/CodeMirror';
import { getCodeMirrorOptions } from './helpers';

const TwigFileCode = ({
  content,
  title,
  isFullScreen,
  filename,
  onChange,
  onFullScreen,
}) => {
  const options = useMemo(() => getCodeMirrorOptions(filename), [filename]);

  return (
    <>
      <div className="twig-files-code__header">
        <div className="twig-files-code__header-filename">{title}</div>
        <div className="twig-files-code__header-actions">
          <Button bsSize="xs" onClick={onFullScreen}>
            <i className={classNames({
              'fas fa-expand': !isFullScreen,
              'fas fa-compress-wide': isFullScreen,
            })}
            />
            {' '}
            Full screen
          </Button>
        </div>
      </div>
      <div className="twig-files-code__body">
        <CodeMirror
          options={options}
          onChange={onChange}
          value={content}
        />
      </div>
    </>
  );
}

TwigFileCode.propTypes = {
  isFullScreen: PropTypes.bool,
  title: PropTypes.string,
  content: PropTypes.string,
  filename: PropTypes.string,
  onChange: PropTypes.func,
  onFullScreen: PropTypes.func,
};

export default memo(TwigFileCode, (prevProps, nextProps) => isEqual(prevProps.title, nextProps.title)
  && isEqual(prevProps.isFullScreen, nextProps.isFullScreen)
  && isEqual(prevProps.filename, nextProps.filename)
  && isEqual(prevProps.content, nextProps.content));
